import { useMemo } from 'react';
import { UseSheetTheme } from '../../../hooks/useSheetTheme';
import { ReturnTypeofSheetSectionsSelector } from '../../../selectors/sheetUiSelector';
import { Box } from '@chakra-ui/react';
import {
  GetGroupParams,
  startRenderGroups,
} from '../../../helpers/renderGroups';
import { HeaderControllerView, HeaderGroupView } from './HeaderGroups';
import { UseGridOperations } from '../../../hooks/useGridOperations';

interface RowGroupsProps
  extends ReturnTypeofSheetSectionsSelector,
    Pick<
      UseSheetTheme,
      'stroke' | 'isRtl' | 'fill' | 'secondaryFill' | 'isDarkTheme'
    >,
    Pick<UseGridOperations, 'openContextMenu'> {
  sheetId: string;
  y: number;
  gridHeight: number;
}
const RowGroups: React.FC<RowGroupsProps> = (props) => {
  const getGroupControlView = (params: GetGroupParams) => (
    <HeaderControllerView
      {...params}
      zoom={props.zoom}
      isRtl={props.isRtl}
      isDarkTheme={props.isDarkTheme}
      key={`${params.group.id}-row-control`}
      openContextMenu={props.openContextMenu}
    />
  );

  const getGroupView = (params: GetGroupParams) => (
    <HeaderGroupView
      {...params}
      zoom={props.zoom}
      isRtl={props.isRtl}
      key={`${params.group.id}-row`}
      isDarkTheme={props.isDarkTheme}
      openContextMenu={props.openContextMenu}
    />
  );

  const Groups = useMemo(() => {
    return startRenderGroups(props, getGroupView, getGroupControlView);
  }, [props.rowViewport, props.isRtl, props.isDarkTheme]);

  const headerSum = props.colHeaderHeight + props.colFilterHeight;
  return (
    <Box
      top={`${props.y}px`}
      width={`${props.rowGroupBarWidth}px`}
      position="relative"
      height={`${props.gridHeight - headerSum}px`}
      display="inline-block"
    >
      {Groups}
    </Box>
  );
};

export default RowGroups;
